import Root from "./root";
import { UserConfig } from "./types";
import { initialData } from "./initial-data";
import {
  PuckAccordionList,
  PuckButtonGroup,
  PuckCheckList,
  PuckFeatureCard,
  PuckImage,
  PuckLogoSlider,
  PuckMedia,
  PuckModal,
  PuckProfileCard,
  PuckSectionHeader,
  PuckTestimonialCard,
  PuckvideoTestimonialCard,
} from "./components";
import {
  PuckDivider,
  PuckFlex,
  PuckGrid,
  PuckMasonryGrid,
  PuckSpace,
  PuckWrapper,
} from "./blocks";

export const puckConfig: UserConfig = {
  root: Root,
  categories: {
    layout: {
      title: "Layout",
      components: [
        "Grid",
        "Space",
        "Wrapper",
        "Flex",
        "Divider",
        "MasonaryGrid",
      ],
    },
    typography: {
      // components: ["Heading", "Text"],
    },
    interactive: {
      title: "Actions",
      // components: ["Button"],
    },
    other: {
      title: "Components",
      components: [
        "Accordion",
        "SectionHeader",
        "Media",
        "ButtonGroup",
        "CheckList",
        "TestimonialCard",
        "FeatureCard",
        "LogoSlider",
        "Modal",
        "Image",
        "ProfileCard",
        "VideoTestimonialCard",
      ],
    },
  },
  components: {
    // components
    SectionHeader: PuckSectionHeader,
    Accordion: PuckAccordionList,
    Media: PuckMedia,
    ButtonGroup: PuckButtonGroup,
    Divider: PuckDivider,
    ProfileCard: PuckProfileCard,
    CheckList: PuckCheckList,
    TestimonialCard: PuckTestimonialCard,
    FeatureCard: PuckFeatureCard,
    LogoSlider: PuckLogoSlider,
    Modal: PuckModal,
    Image: PuckImage,
    VideoTestimonialCard: PuckvideoTestimonialCard,
    // blocks
    Grid: PuckGrid,
    Space: PuckSpace,
    Wrapper: PuckWrapper,
    Flex: PuckFlex,
    MasonaryGrid: PuckMasonryGrid,
  },
};

export const componentKey = Buffer.from(
  `${Object.keys(puckConfig.components).join("-")}-${JSON.stringify(initialData)}`,
).toString("base64");

export default puckConfig;
